<!--
 * @Date: 2020-05-18 14:00:54
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-29 14:21:41
 * @FilePath: /xy-pc/src/views/userCenter/studentMange/index.vue
--> 
<template>
  <div class="student_myclass" style="width:100%">
    <el-tabs v-model="activeName">
      <el-tab-pane label="学员管理" name="first">
        <el-table :data="tableData" size="small" style="width: 100%">
          <el-table-column label="头像" width="180">
            <template slot-scope="scope">
              <el-image :src="scope.row.user.avatar" class="list-img"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="姓名" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.user.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号码" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.user.mobile }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态" width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.status==-1" class="type1">待审核</span>
              <span v-if="scope.row.status==1" class="type2">已绑定</span>
              <span v-if="scope.row.status==2" class="type1">解除绑定</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" class="btn-box">
              <el-button type="text" @click="showDetail(scope.row,2)">查看</el-button>
              <el-button
                type="text"
                @click="changeUserStatus(2,scope.row.id)"
                v-if="scope.row.status==-1"
              >不通过</el-button>
              <el-button
                type="text"
                @click="changeUserStatus(1,scope.row.id)"
                v-if="scope.row.status==-1"
              >通过</el-button>
              <el-button type="text" @click="showDetail(scope.row,1)" v-if="scope.row.status==1">报名</el-button>
              <el-button
                type="text"
                @click="changeUserStatus(2,scope.row.id)"
                v-if="scope.row.status==1"
              >解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin:20px 0 40px;text-align: center;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="limit"
            layout=" sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 编辑 -->
    <el-dialog :visible.sync="showEditMes" width="800px">
      <div>
        <el-form
          ref="editForm"
          label-position="left"
          :rules="dataRule"
          :model="editForm"
          label-width="100px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="证件照片：" required class="form_tiem">
                <el-upload
                  class="avatar-uploaders"
                  :action="action"
                  :show-file-list="false"
                  :data="uploadData"
                  :on-change="(res)=>imgPreview(res,'photoRevw')"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <el-image
                    style="width:100px;height:140px"
                    v-if="editForm.photo"
                    :src="editForm.photoRevw"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="专业：" class="form_tiem" prop="professional">
                <el-input v-model="editForm.professional" style="width:234px"></el-input>
              </el-form-item>
              <el-form-item label="身份证号：" class="form_tiem" prop="identity_card">
                <el-input maxlength="18" v-model="editForm.identity_card" style="width:234px"></el-input>
              </el-form-item>

              <el-form-item label="岗位：" class="form_tiem" prop="duties">
                <el-cascader
                  style="width:234px"
                  ref="myCascader"
                  v-model="editForm.duties"
                  :options="posList"
                  :props="{ label: 'name' ,value:'id',multiple:true}"
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="性别：" class="form_tiem" prop="sex">
                <el-radio v-model="editForm.sex" :label="1">男</el-radio>
                <el-radio v-model="editForm.sex" :label="2">女</el-radio>
              </el-form-item>
              <el-form-item label="学历：" class="form_tiem" prop="academic_certificate_type">
                <el-select
                  v-model="editForm.academic_certificate_type"
                  placeholder="请选择"
                  style="width:234px"
                >
                  <el-option
                    v-for="item in optionsvalue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="毕业院校：" class="form_tiem" prop="school">
                <el-input v-model="editForm.school" style="width:234px"></el-input>
              </el-form-item>

              <el-form-item label="技术职称：" class="form_tiem" prop="technical_title">
                <el-input v-model="editForm.technical_title" style="width:234px"></el-input>
              </el-form-item>
              <el-form-item label="邮箱地址：" class="form_tiem" prop="email">
                <el-input v-model="editForm.email" style="width:234px"></el-input>
              </el-form-item>
              <el-form-item label="分类：" class="form_tiem">
                <el-select v-model="editForm.sign_up_type" placeholder="请选择" style="width:234px">
                  <el-option
                    v-for="item in optionSign_up"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- 根据按钮切换对应的按钮 -->
        <!-- 通过和不通过是未审批状态下显示
            撤  销是审批通过下显示
        确认撤 销 是填写原因下显示-->

        <el-button type="primary" @click="editUserInfo">确定</el-button>
      </span>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog :visible.sync="showDetailMes" width="30%" center>
      <div>
        <div class="first-head">
          <el-image style="width:40px;height:40px;border-radius:30px" :src="detailForm.photo"></el-image>
          <div>
            <span class="name">{{detailForm.user.name}}</span>
            <span>{{detailForm.user.mobile}}</span>
          </div>
          <div style="float:right;line-height:58px" v-if="detailForm.status==-1" class="type1">未审批</div>
          <div style="float:right;line-height:58px" v-if="detailForm.status==2" class="type1">撤销通过</div>
          <div style="float:right;line-height:58px" v-if="detailForm.status==1" class="type2">审批通过</div>
        </div>
        <div class="dialog-box">
          <label>性别：</label>
          <span style="margin-right:80px">{{detailForm.sex==1?'男':'女'}}</span>
          <label>出生年月：</label>
          <span>{{detailForm.brith}}</span>
        </div>
        <div class="dialog-box">
          <label>手机号：</label>
          <span>{{detailForm.user.mobile}}</span>
        </div>
        <!-- <div class="dialog-box">
          <label>岗位技术：</label>
          <span>{{detailForm.professional}}</span>
        </div>-->
        <div class="dialog-box">
          <label>身份证号：</label>
          <span>{{detailForm.identity_card}}</span>
        </div>
        <div class="dialog-box">
          <label>邮箱：</label>
          <span>{{detailForm.email}}</span>
        </div>
        <div class="dialog-box">
          <label>毕业院校：</label>
          <span>{{detailForm.school}}</span>
        </div>
        <div class="dialog-box">
          <label>分类：</label>
          <span>{{detailForm.sign_up_type==1?'新训':detailForm.sign_up_type==2?'换证':detailForm.sign_up_type==3?'补考':'增岗'}}</span>
        </div>
        <div class="dialog-box">
          <label>学历：</label>
          <span
            style="margin-right:80px"
          >{{detailForm.academic_certificate_type==1?'高中':detailForm.academic_certificate_type==2?'本科':detailForm.academic_certificate_type==3?'研究生':'其他'}}</span>
          <label>专业：</label>
          <span>{{detailForm.professional}}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 根据按钮切换对应的按钮 -->
        <!-- 通过和不通过是未审批状态下显示
            撤  销是审批通过下显示
        确认撤 销 是填写原因下显示-->

        <el-button type="primary" @click="showDetailMes=false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "student_mange",

  data() {
    return {
      showEditMes: false, //完善信息显隐
      showDetailMes: false, //详情显隐
      photoChange: false,

      action: window.baseUrl + "/api/v1/upload",
      uploadData: { folder: "images" },
      editForm: {
        sex: 1,
        dutiesname: [],
        duties: [],
        photoRevw: "",
        sign_up_type: 1,
      }, //学员信息编辑
      detailForm: {
        user: {},
      }, //学员详情
      dataRule: {
        duties: {
          required: true,
          message: "请选择岗位",
          trigger: "blur",
        },
        email: {
          message: "请输入邮箱",
          trigger: "blur",
        },
        identity_card: {
          required: true,
          message: "请输入身份证号码",
          trigger: "blur",
        },
        academic_certificate_type: {
          required: true,
          message: "请选择学历",
          trigger: "blur",
        },

        sex: {
          required: true,
          message: "请选择性别",
          trigger: "blur",
        },
        professional: {
          required: true,
          message: "请输入专业",
          trigger: "blur",
        },
        technical_title: {
          message: "请输入技术职称",
          trigger: "blur",
        },
        sign_up_type: {
          message: "请选择分类",
          trigger: "blur",
        },

        school: {
          required: true,
          message: "请输入学校",
          trigger: "blur",
        },
      },
      tableData: [], //列表数据
      posList: [],
      value: [],
      value3: "",
      activeName: "first",
      form: "",
      radio: "1",
      value1: "",
      optionsvalue: [
        { value: 1, label: "高中" },
        { value: 5, label: "大专" },
        { value: 2, label: "本科" },
        { value: 3, label: "研究生" },
        { value: 4, label: "其他" },
      ],
      optionSign_up: [
        { value: 1, label: "新训" },
        { value: 2, label: "换证" },
        { value: 3, label: "补考" },
        { value: 4, label: "增岗" },
      ],

      total: 0,
      page: 1,
      limit: 10,
    };
  },

  created() {
    this.getDataList();
    this.getPosList();
  },

  methods: {
    changeVCal(val) {
      console.log(this.editForm);
    },
    handleAvatarSuccess(res, file) {
      if (res.status == 200) {
        this.editForm = Object.assign({}, this.editForm, {
          photo: res.data.url,
        });
        this.photoChange = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    imgPreview(file, name) {
      console.log(file.raw);
      const thisVue = this;

      const reader = new FileReader(); // 创建读取文件对象
      reader.readAsDataURL(file.raw); // 发起异步请求，读取文件
      reader.onload = function () {
        // 文件读取完成后
        // 读取完成后，将结果赋值给img的src
        // console.log(reader)
        thisVue.editForm[name] = reader.result;
      };
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    /**获取学员列表 */
    getDataList() {
      this.$http({
        url: "api/v1/auth/station-users",
        method: "get",
        params: {
          page: this.page,
          limit: this.limit,
        },
      }).then((res) => {
        if (res.status == 200) {
          this.tableData = res.data.stationUsers;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    /**获取岗位信息 */
    getPosList() {
      this.$http({
        url: "api/v1/duties/all",
        method: "get",
      }).then((res) => {
        console.log(res);
        if (res.status == 200) {
          this.posList = res.data.duties;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**查看/编辑详情 */

    showDetail(row, type) {
      this.$http({
        url: "api/v1/auth/station-users/" + row.id,
        method: "get",
      }).then((res) => {
        if (res.status == 200) {
          if (type == 1) {
            this.editForm = {};
            this.editForm = Object.assign(
              {
                sign_up_type: res.data.stationUser.sign_up_type || 1,
              },
              this.editForm,
              res.data.stationUser
            );
            this.editForm.sex = this.editForm.sex - 0;
            let dutiesList = this.editForm.duties.map((item) => [
              item.pid,
              item.id,
            ]);
            this.editForm.duties = dutiesList;
            this.editForm.photoRevw = this.editForm.photo;
            // this.editForm.sign_up_type = this.editForm.sign_up_type||'14';

            this.showEditMes = true;
          } else {
            this.detailForm = Object.assign(
              {},
              this.detailForm,
              res.data.stationUser
            );
            this.showDetailMes = true;
          }
        } else {
          this.$message.error(res.msg);
        }
        console.log(this.editForm);
      });
    },
    /**审核学员 */
    changeUserStatus(status, id) {
      this.$http({
        url: "api/v1/auth/station-users/" + id,
        method: "PATCH",
        data: {
          status: status, //	状态(1通过 2拒绝)
        },
      }).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getDataList();
            },
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    groupArr(list, field) {
      var fieldList = [],
        att = [];
      list.map((e) => {
        fieldList.push(e[0]);
      });
      //数组去重
      fieldList = fieldList.filter((e, i, self) => {
        return self.indexOf(e) == i;
      });
      for (var j = 0; j < fieldList.length; j++) {
        //过滤出匹配到的数据
        var arr = list.filter((e) => {
          return e[0] == fieldList[j];
        });
        att.push({
          type: arr[0][0],
          list: arr,
        });
      }
      return att;
    },
     groupArrs(list) {
      var fieldList = [],
        att = [];
      list.map((e) => {
        fieldList.push(e.parent);
      });
      //数组去重
      fieldList = fieldList.filter((e, i, self) => {
        console.log(e, i, self);
        return self.indexOf(e) == i;
      });
      let obj = {};

      fieldList = fieldList.reduce((cur, next) => {
        obj[next.data.id]
          ? ""
          : (obj[next.data.id] = true && cur.push(next.data));
        return cur;
      }, []); //设置cur默认类型为数组，并且初始值为空的数组
      for (var j = 0; j < fieldList.length; j++) {
        //过滤出匹配到的数据
        var arr = list.filter((e) => {
          return e.parent.data.id == fieldList[j].id;
        });
        arr = arr.map((item) => item.data);
        att.push({
          type: fieldList[j].id,
          list: arr,
        });
      }
      return att;
    },
    /**学员信息完善*/
    editUserInfo() {
      let duties = [];
      let checkNodes = this.$refs.myCascader.getCheckedNodes();
      let validDuties = this.groupArrs(checkNodes);

      if (validDuties.length > 3) {
        this.$message.error("最多选三个一级分类岗位");
        return false;
      }
      for (let i = 0; i < validDuties.length; i++) {
        let list = validDuties[i].list.filter((item) => item.is_virtual == -1);
        console.log(list);
        if (list.length > 3) {
          this.$message.error("每个一级分类下最多选三个二级分类岗位");
          return false;
        }
      }


      if (this.editForm.duties && this.editForm.duties.length > 0) {
        duties = this.editForm.duties.map((item) => item[1]);
      }

      if (!this.editForm.photo) {
        this.$message.error("请上传证件照");
        return false;
      }
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "api/v1/auth/station-users/" + this.editForm.id,
            method: "PUT",
            data: {
              sex: this.editForm.sex,
              identity_card: this.editForm.identity_card,
              email: this.editForm.email,
              school: this.editForm.school,
              professional: this.editForm.professional,
              photo: this.editForm.photo,
              technical_title: this.editForm.technical_title,
              sign_up_type: this.editForm.sign_up_type,

              academic_certificate_type: this.editForm
                .academic_certificate_type,
              duties: duties,
            },
          })
            .then((res) => {
              if (res.status == 200) {
                this.$message({
                  message: res.msg,
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.showEditMes = false;
                    this.getDataList();
                  },
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              if (err.response.data && err.response.data.errors) {
                let obj = err.response.data.errors;
                let errorMess = obj[Object.keys(obj)[0]];
                this.$message.error(errorMess[0]);
              }
            });
        }
      });
    },
    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getDataList();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getDataList();
    },
    handleEdit() {
      this.showEditMes = true;
    },
    handleChange() {},
    handleDelete(index, row) {
      console.log(index, row);
    },
  },
};
</script>
<style lang="less" >
.avatar-uploaders {
  width: 100px;
  height: 140px;
  .el-upload {
    width: 100px;
    height: 140px;
  }
}
</style>
<style lang="less" scoped>
.contant_list {
  padding-top: 36px 30px;
  width: 100%;
}
.first-head {
  height: 58px;
  img {
    height: 58px;
    width: 58px;
    float: left;
    margin-right: 13px;
    border-radius: 30px;
  }
  div {
    float: left;
    height: 100%;
    span {
      display: block;
      height: 50%;
      line-height: 29px;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
    }
    .name {
      color: rgba(0, 0, 0, 1);
      font-size: 19px;
    }
  }
}

.list-img {
  height: 35px;
  width: 35px;
  border-radius: 18px;
}
.type1 {
  color: rgba(253, 12, 12, 1);
}
.type2 {
  color: rgba(4, 193, 81, 1);
}
.btn-box a:hover {
  color: rgba(42, 130, 228, 0.8);
}
.btn1 {
  margin-right: 26px;
  display: inline-block;
  color: rgba(42, 130, 228, 1);
}
.btn2 {
  color: rgba(42, 130, 228, 1);
}
.dialog-box {
  height: 36px;
  line-height: 36px;
}
</style>